// LICENSE_CODE ZON ISC
'use strict';

/*jslint browser:true, es6:true*/
define(['/util/csrf.js', '/util/storage.js', '/util/etask.js', '/util/url.js', '/util/zerr.js'], function (csrf, storage, etask, zurl, zerr) {
  var E = {};
  E.is_silent = true;
  try {
    E.is_silent = !storage.get('fetch_logs', false);
  } catch (e) {}
  function build_params(prefix, obj, add) {
    var name;
    if (Array.isArray(obj)) {
      obj.forEach((el, i) => {
        build_params(prefix + '[' + (typeof el == 'object' && el != null ? i : '') + ']', el, add);
      });
    } else if (typeof obj == 'object' && obj != null) {
      for (name in obj) build_params(prefix + '[' + name + ']', obj[name], add);
    } else add(prefix, obj);
  }
  var r20 = /%20/g;
  var param_to_staring = a => {
    var prefix,
      s = [],
      add = (key, value) => {
        var is_fn = typeof value == 'function';
        value = is_fn ? value() : value == null ? '' : value;
        s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      };
    if (Array.isArray(a)) a.forEach((el, i) => add(i, el));else {
      for (prefix in a) build_params(prefix, a[prefix], add);
    }
    return s.join('&').replace(r20, '+');
  };
  E.fetch = function (url, params) {
    if (!E._fetch) throw new Error('Call fetch, before initialization');
    return E._fetch(url, params);
  };
  var with_slow = (et, args, opt) => {
    opt = opt || {};
    var timeout = opt.timeout || 3000;
    var start = Date.now();
    var is_slow = false;
    var timer = setTimeout(() => {
      is_slow = true;
      zerr.warn('SLOW-progress fetch ' + args.join(' '));
    }, timeout);
    et.finally(() => {
      clearTimeout(timer);
      if (is_slow) {
        zerr.warn(Date.now() - start + 'ms SLOW-finished fetch ' + args.join(' '));
      }
    });
    return et;
  };

  // native fetch rejects with TypeError on network failure; it is not a code bug
  var net_err = e => {
    if (!(e instanceof TypeError)) throw e;
    var err = new Error(e.message);
    err.cause = e;
    throw err;
  };
  E.init = function (custom_fetch) {
    if (E.patch_done) return;
    E.patch_done = true;
    var fetch_origin = custom_fetch ? custom_fetch : self.fetch;
    var call_origin = (url, params) => with_slow(etask(function* () {
      var origin_res = fetch_origin(url, params);
      var res = yield origin_res instanceof Promise ? origin_res.catch(net_err) : origin_res;
      var text;
      try {
        text = yield res.text();
      } catch (e) {
        if (!E.is_silent) zerr.err(e.message);
        e.hola_info = {
          url,
          method: params.method,
          status: res.status,
          status_text: res.statusText
        };
        return e;
      }
      if (!res.ok) {
        var err = new Error();
        err.hola_info = {
          url,
          method: params.method,
          status: res.status,
          response_text: text,
          status_text: res.statusText
        };
        err.x_error = res.headers.get('X-Luminati-Error') || res.headers.get('X-Hola-Error');
        return err;
      }
      var result_data = text;
      try {
        result_data = JSON.parse(text);
      } catch (e) {}
      return result_data;
    }), [params.method || 'GET', url], {
      timeout: 3000
    });
    // XXX dmitriiz: path fetch with etask
    E._fetch = function (url, params) {
      if (!params) params = {};
      if (!params.headers) params.headers = {};
      if (params.method == 'POST' || params.method == 'PUT' || params.method == 'PATCH' || params.method == 'DELETE') {
        var current = zurl.parse(location.href, true);
        var target = zurl.parse(url, true);
        if (!target.host || target.protocol == current.protocol && target.host == current.host) {
          params.headers['X-XSRF-Token'] = csrf.get(url);
        }
        if (!params.auto_content_type) {
          params.headers['Content-Type'] = params.contentType || params.json ? 'application/json; charset=UTF-8' : 'application/x-www-form-urlencoded; charset=UTF-8';
        }
      }
      if (params.xhrFields && params.xhrFields.withCredentials) params.credentials = 'include';
      params.headers.Accept = '*/*';
      if (params.cache === false) params.cache = 'no-cache';
      var controller;
      // XXX dmitriiz: check implementation for Node
      if (!params.signal && self && self.AbortController) {
        controller = new self.AbortController();
        var signal = controller.signal;
        params.signal = signal;
      }
      if (!params.contentType && params.body && !(params.body instanceof FormData) && typeof params.body == 'object') {
        params.body = params.json ? JSON.stringify(params.body) : param_to_staring(params.body);
      }
      var id = params.timeout && setTimeout(() => {
        if (!E.is_silent) zerr.err('Timeout: %s', url);
        if (controller) controller.abort();
      }, params.timeout);
      return params.et = etask([function* () {
        this.finally(() => clearTimeout(id));
        var res;
        try {
          res = yield call_origin(url, params);
        } catch (e) {
          res = e;
        }
        if (res instanceof Error) {
          var hola_info = res.hola_info || {};
          if (params.no_throw) {
            return {
              err: res,
              error: res,
              url: hola_info.url || url,
              method: hola_info.method || params.method,
              status: hola_info.status || 0,
              data: hola_info.response_text
            };
          }
          throw res;
        }
        return res;
      }, function cancel$() {
        if (controller) controller.abort();
      }]);
    };
    if (typeof self != 'undefined') self.hola_fetch = E._fetch;
  };
  return E;
});